import React, { useContext } from 'react'
import { BodyPartHighlighter, effectsAndImpacts } from 'shared-ui'
import BodyPart from '../../context/BodyPart'

const { getModelHighlightsFromTests } = effectsAndImpacts

export default function HealthEffectsMap({ tests = [], filter, ...props }) {

    // filter:   all, severe, light, positive, negative

    const [partFocus, setPartFocus] = useContext(BodyPart)

    const highlights = getModelHighlightsFromTests(tests, 'player', Infinity, filter)

    const handlePartClick = (bodyPart) => {
        if (partFocus === bodyPart) {
            setPartFocus('')
        } else {
            setPartFocus(bodyPart)
        }
    }

    const handleEnter = (bodyPart) => {
        setPartFocus(bodyPart)
    }

    const handleLeave = () => {
        setPartFocus('')
    }

    return (
        <BodyPartHighlighter
            focusedPart={partFocus}
            highlights={highlights}
            onPartClick={handlePartClick}
            onPartMouseEnter={handleEnter}
            onPartMouseLeave={handleLeave}
            {...props}
        />
    )
}